/* eslint-disable @typescript-eslint/naming-convention */
import { Entity } from '../entity/index';
import { PageTitles } from '../interfaces/types';

export interface IFeatureCollection {
  crs: ICrs;
  features: IFeature[];
  numberMatched: number;
  numberReturned: number;
  timeStamp: Date;
  totalFeatures: number;
  type: string;
}

export interface IFeature {
  id: string;
  type: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  geometry_name: string;
  geometry: {
    type: string;
    coordinates: any;
  };
  properties: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    created_at: Date;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    created_by: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modified_at: Date;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modified_by?: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    postal_code?: string;
  };
}

interface ICrs {
  type: string;
  properties: {
    name: string;
  };
}

@Entity({
  name: PageTitles.featureCollection,
})
export class FeatureCollection implements IFeatureCollection {
  private state: IFeatureCollection;

  constructor(featureCollection: IFeatureCollection) {
    this.state = featureCollection;
  }

  get crs(): ICrs {
    return this.state.crs;
  }

  get features(): IFeature[] {
    return this.state.features;
  }

  get numberMatched(): number {
    return this.state.numberMatched;
  }

  get numberReturned(): number {
    return this.state.numberReturned;
  }

  get timeStamp(): Date {
    return this.state.timeStamp;
  }

  get totalFeatures(): number {
    return this.state.totalFeatures;
  }

  get type(): string {
    return this.state.type;
  }
}

export enum FILTER_OPERATORS {
  '=' = 'PropertyIsEqualTo',
  '!=' = 'PropertyIsNotEqualTo',
  '<' = 'PropertyIsLessThan',
  'MTM' = 'PropertyIsLessThan',
  '<=' = 'PropertyIsLessThanOrEqualTo',
  '>' = 'PropertyIsGreaterThan',
  'IC' = 'PropertyIsGreaterThan',
  '>=' = 'PropertyIsGreaterThanOrEqualTo',
  'NC' = 'PropertyIsGreaterThan',
  null = 'PropertyIsNull',
  'NT' = 'PropertyIsLessThan',
  'MDU' = 'PropertyIsEqualTo',
}

export enum FILTER_OPERATORS_BETWEEN {
  'NT' = 'PropertyIsGreaterThan',
  'MDU' = 'PropertyIsEqualTo',
}
